import {request} from '@umijs/max';

export async function getDeviceList(params: DEVICE.ListParams) {
  return request('/miot/api/rest/v2/device/devices', {
    params
  });
}

export async function getDeviceByList(params: DEVICE.ListParams) {
  return request('/miot/api/rest/v2/device/devices/byList', {
    params
  })
}

export async function getDeviceById(deviceId: string, params: DEVICE.DeviceParams = {}) {
  return request(`/miot/api/rest/v2/device/devices/${deviceId}`, {
    params
  })
}

export async function createDevice(data: DEVICE.Form, skipErrorHandler = false) {
  return request('/miot/api/rest/v2/device/devices', {
    method: 'POST',
    data,
    skipErrorHandler
  });
}

export async function updateDevice(data: DEVICE.Form, deviceId: string) {
  return request(`/miot/api/rest/v2/device/devices/${deviceId}`, {
    method: 'PUT',
    data
  });
}

export async function deleteDevice(deviceId: string) {
  return request(`/miot/api/rest/v2/device/devices/${deviceId}`, {
    method: 'DELETE'
  });
}

export async function getDeviceTypeNums() {
  return request('/miot/api/rest/v2/device/devices/stat/groupByType', {
    method: 'GET'
  });
}

export async function getDeviceStatusNums() {
  return request('/miot/api/rest/v2/device/devices/stat/byStatus');
}
